(function () {
  'use strict';
  function init() {
    var input = document.getElementById('fhub-search-input');
    var resultsEl = document.getElementById('fhub-search-results');
    var dataEl = document.getElementById('fhub-search-data');
    if (!input || !resultsEl || !dataEl) return;
    var data = [];
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      data = [];
    }
    var currentMatches = [];

    function render(matches, query) {
      currentMatches = matches;
      resultsEl.innerHTML = '';
      if (query.trim() === '') {
        resultsEl.hidden = true;
        return;
      }
      if (matches.length === 0) {
        var empty = document.createElement('li');
        empty.className = 'fhub__result-empty';
        empty.textContent = 'No matching articles — try a different search.';
        resultsEl.appendChild(empty);
        resultsEl.hidden = false;
        return;
      }
      matches.slice(0, 8).forEach(function (item, index) {
        var li = document.createElement('li');
        li.className = 'fhub__result-item';
        var a = document.createElement('a');
        a.href = item.url;
        a.setAttribute('data-result-index', index);
        var q = document.createElement('span');
        q.className = 'fhub__result-q';
        q.textContent = item.q;
        var meta = document.createElement('span');
        meta.className = 'fhub__result-meta';
        meta.textContent = item.cat;
        a.appendChild(q);
        a.appendChild(meta);
        li.appendChild(a);
        resultsEl.appendChild(li);
      });
      resultsEl.hidden = false;
    }

    function search(query) {
      var q = query.trim().toLowerCase();
      if (q === '') return [];
      return data.filter(function (item) {
        return (
          (item.q && item.q.toLowerCase().indexOf(q) !== -1) ||
          (item.a && item.a.toLowerCase().indexOf(q) !== -1) ||
          (item.cat && item.cat.toLowerCase().indexOf(q) !== -1)
        );
      });
    }

    var debounceTimer;
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var value = input.value;
      debounceTimer = setTimeout(function () {
        render(search(value), value);
      }, 120);
    });

    // Enter jumps straight to the top result. Arrow keys move focus
    // between results so the keyboard-only flow works end to end.
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        if (currentMatches.length > 0) {
          e.preventDefault();
          window.location.href = currentMatches[0].url;
        }
        return;
      }
      if (e.key === 'ArrowDown' && !resultsEl.hidden) {
        var first = resultsEl.querySelector('a[data-result-index]');
        if (first) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    resultsEl.addEventListener('keydown', function (e) {
      var links = Array.prototype.slice.call(resultsEl.querySelectorAll('a[data-result-index]'));
      var currentIndex = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = links[currentIndex + 1] || links[0];
        if (next) next.focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (currentIndex <= 0) {
          input.focus();
        } else {
          links[currentIndex - 1].focus();
        }
      } else if (e.key === 'Escape') {
        resultsEl.hidden = true;
        input.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.fhub__search-wrap')) {
        resultsEl.hidden = true;
      }
    });

    input.addEventListener('focus', function () {
      if (input.value.trim() !== '') {
        render(search(input.value), input.value);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
